export default __webpack_public_path__ + "static/media/1.6bd84db7.png";